export default {
  root: {
    marginBottom: 5,
  },
};
